import { render, staticRenderFns } from "./PendingExternalProductsPanel.vue?vue&type=template&id=f7c9cf7a&scoped=true"
import script from "./PendingExternalProductsPanel.vue?vue&type=script&lang=js"
export * from "./PendingExternalProductsPanel.vue?vue&type=script&lang=js"
import style0 from "./PendingExternalProductsPanel.vue?vue&type=style&index=0&id=f7c9cf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c9cf7a",
  null
  
)

export default component.exports